import * as React from 'react'

function IconRectangleComplete({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={154}
      viewBox="0 0 104 154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter2_rectangle)">
            <path
              d="M87.701 152.072H16.3c0-8.447-6.853-15.3-15.299-15.3V16.3c8.446 0 15.299-6.853 15.299-15.3H87.7c0 8.447 6.853 15.3 15.299 15.3v120.472c-8.446 0-15.299 6.853-15.299 15.3z"
              fill="#fff"
            />
            <path
              d="M87.701 152.072H16.3c0-8.447-6.853-15.3-15.299-15.3V16.3c8.446 0 15.299-6.853 15.299-15.3H87.7c0 8.447 6.853 15.3 15.299 15.3v120.472c-8.446 0-15.299 6.853-15.299 15.3z"
              stroke={color}
              strokeWidth={2}
              strokeMiterlimit={10}
            />
            <path
              d="M24.102 142.254a25.293 25.293 0 00-13.285-13.286V24.132a25.29 25.29 0 0013.285-13.286H79.9a25.29 25.29 0 0013.285 13.286v104.836a25.294 25.294 0 00-13.285 13.286H24.102z"
              fill={color}
            />
            <path
              d="M68.907 65.092l-22.882 22.89-11.453-11.445"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <filter
              id="filter2_rectangle"
              x={0}
              y={0}
              width={104}
              height={153.072}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M87.701 152.072H16.3c0-8.447-6.853-15.3-15.299-15.3V16.3c8.446 0 15.299-6.853 15.299-15.3H87.7c0 8.447 6.853 15.3 15.299 15.3v120.472c-8.446 0-15.299 6.853-15.299 15.3z"
            fill="#fff"
          />
          <path
            d="M87.701 152.072H16.3c0-8.447-6.853-15.3-15.299-15.3V16.3c8.446 0 15.299-6.853 15.299-15.3H87.7c0 8.447 6.853 15.3 15.299 15.3v120.472c-8.446 0-15.299 6.853-15.299 15.3z"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M24.102 142.254a25.293 25.293 0 00-13.285-13.286V24.132a25.29 25.29 0 0013.285-13.286H79.9a25.29 25.29 0 0013.285 13.286v104.836a25.294 25.294 0 00-13.285 13.286H24.102z"
            stroke={color}
            strokeWidth={0.75}
            strokeMiterlimit={10}
          />
          <path
            d="M68.907 65.092l-22.882 22.89-11.453-11.445"
            stroke="#219321"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRectangleComplete
